module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.tagplayContainer
  }, [_c('div', {
    class: _vm.$style.columns
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      class: _vm.$style.column
    }, [_c('div', {
      staticClass: "tagplay-media-container tagplay-media-instagram"
    }, [_c('div', {
      staticClass: "tagplay-media-inner"
    }, [_c('p', {
      staticClass: "tagplay-media-username"
    }, [_c('a', {
      attrs: {
        "href": ("https://instagram.com/" + (post.username)),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(post.username))])]), _vm._v(" "), _c('div', {
      staticClass: "tagplay-media"
    }, [_c('a', {
      staticClass: "tagplay-media-link",
      attrs: {
        "href": ("https://www.instagram.com/p/" + (post.post) + "/"),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "tagplay-media-object",
      attrs: {
        "src": ("https://instagram.com/p/" + (post.post) + "/media/?size=l")
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "tagplay-media-text"
    }, [_c('strong', [_vm._v("Ljósmyndari:")]), _c('br'), _vm._v("\n          " + _vm._s(post.name)), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Verðlaun:")]), _c('br'), _vm._v("\n          " + _vm._s(post.prize) + "\n        ")])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-868268c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Winners.vue
// module id = 30
// module chunks = 0